import { useEffect } from 'react';

export const useTawk = () => {
  useEffect(() => {
    // Prevent loading twice
    if (document.getElementById('tawk-script')) return;

    const script = document.createElement('script');
    script.id = 'tawk-script';
    script.async = true;
    script.src = `https://embed.tawk.to/${process.env.REACT_APP_EXPO_PUBLIC_TAWK_TO_ID}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    document.body.appendChild(script);

    return () => {
      // Optional: remove script on unmount
      // document.getElementById("tawk-script")?.remove();
    };
  }, []);
};
